// extracted by mini-css-extract-plugin
export default {"container":"style_container__xnI-I","autoScroll":"style_autoScroll__6WWTE","buttonWrapper":"style_buttonWrapper__ivFX1"};